import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

const NonPartnerRestricted = props => (
	<Fragment>
		<div className="non-partner-restricted">
			<div>
				<h1>
					<FormattedMessage
						id="login.title.non-partner"
						defaultMessage={"Direct access to the Pilotly study experience is not supported."}
					/>
				</h1>
			</div>
		</div>
	</Fragment>
);

export default NonPartnerRestricted;


// WEBPACK FOOTER //
// ./src/pages/NonPartnerRestricted.js